import useDividerStyles from "./use-divider-styles";

interface IProps {
	text: string;
	noBorder?: boolean;
	borderDanger?: boolean;
}

export const DividerWithText: React.FC<IProps> = ({ text, noBorder, borderDanger }) => {
	const { container, border, content, borderContent, borderDangerColor } = useDividerStyles({ noBorder });

	if (!text)
		return (
			<div className={container}>
				<div className={`${border} ${!!borderDanger && borderDangerColor}`} />
			</div>
		);

	return (
		<div className={container}>
			<div className={`${border} ${!!borderDanger && borderDangerColor}`} />
			<div className={`${content} ${!noBorder && borderContent}`}>{text}</div>
			<div className={`${border} ${!!borderDanger && borderDangerColor}`} />
		</div>
	);
};
